import {FC, useEffect} from "react";
import styled from "@emotion/styled";
import {MobileMenu} from "./MobileMenu";
import {DesktopMenu} from "./DesktopMenu";
import bgc from "assets/images/headerBckg.jpeg";
import {breakpoints} from "assets/theme";

const Wrapper = styled.header`
	width: 100%;
	color: ${({theme}) => theme.header.color};
	background-color: ${({theme}) => theme.header.background};

	@media (min-width: ${breakpoints.medium}) {
		background-image: url(${bgc});
		background-repeat: no-repeat;
		background-position: bottom;
	}
`;

export const Header: FC = () => {
	useEffect(() => {
		const customEvent = new CustomEvent("layoutLoaded");
		document.dispatchEvent(customEvent);
	}, []);

	return (
		<Wrapper>
			<DesktopMenu />
			<MobileMenu />
		</Wrapper>
	);
};
